import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import BeeComponents from '@beetronix/bee-components'
import VueMeta from 'vue-meta';
import Edunix from './plugins/edunix'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false
Vue.use(BeeComponents)
Vue.use(VueMeta)
Vue.use(VueApexCharts)
Vue.use(Edunix)
Vue.component('apexchart', VueApexCharts)

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
